import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import massive from "./components/massive";
import lightweight from "./components/lightweight";

const principle: Slide = {
  description:
    "A simple concrete wall separates two rooms. Add massive or lightweight vibration isolated lining to that wall and to other surfaces in the source room. Observe the improvement of sound insulation between the rooms expressed with DnT,w for wideband frequency range and with DnT, 63Hz for low frequencies, compared to the reference state with no lining used.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [{ name: "Massive lining" }, { name: "Lightweight lining" }],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [[], []],
      components: [massive, lightweight],
    },
  },
};

export default principle;
